var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 21H21M4 21V7.5C4 7.22386 4.22386 7 4.5 7H11.5C11.7761 7 12 7.22386 12 7.5V21M7 11H9M7 14H9M7 17H9", stroke: "#303030", strokeLinecap: "round" }),
    React.createElement("path", { d: "M10 7V3.5C10 3.22386 10.2239 3 10.5 3H15.5C15.7761 3 16 3.22386 16 3.5V21M16 10H19.5C19.7761 10 20 10.2239 20 10.5V21", stroke: "#303030", strokeLinecap: "round" })
  );
});